(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ul-legal-guarantee"] && !Shopify.designMode) return;
  try {
    (() => {
    const notice = document.getElementById('ul-guarantee-dialog');
    if (!notice || typeof notice.showModal !== 'function') return;
    let previousOverflow;
    let trigger;
    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-ul-guarantee-open]');
      if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (notice.open) return;
      trigger = link;
      previousOverflow = document.documentElement.style.overflow;
      notice.showModal();
      document.documentElement.style.overflow = 'hidden';
    });
    notice.querySelector('[data-ul-guarantee-close]').addEventListener('click', () => notice.close());
    notice.addEventListener('keydown', (event) => { if (event.key === 'Escape') { event.preventDefault(); notice.close(); } });
    notice.addEventListener('click', (event) => { if (event.target === notice) notice.close(); });
    notice.addEventListener('close', () => {
      document.documentElement.style.overflow = previousOverflow || '';
      trigger?.focus({preventScroll:true});
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
